import React from 'react';
import ReactDOM from 'react-dom/client';
import ReactGA from 'react-ga4';

import App from './App';
import { SharedStateProvider } from './Helpers/SharedState';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css'; // Keep after the bootstrap css

const isProduction = (process.env.NODE_ENV === 'production');

if (isProduction) {
    ReactGA.initialize('G-W7V6HCEZMQ');
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <React.StrictMode>
        <SharedStateProvider>
            <App/>
        </SharedStateProvider>
    </React.StrictMode>
);
